import React from "react";

const ToolbarButton = ({ id, onClick, title, children }) => {
  return (
    <button
      id={id}
      title={title}
      onClick={onClick}
      className='relative flex items-center justify-center text-blue h-8 w-8 mx-2 rounded-lg cursor-pointer hover:bg-blue-200 transition-all'>
      {children}
    </button>
  );
};

export default ToolbarButton;
